/**
 * Handgezeichnete Symbole.
 *
 * Bewusst keine Icon-Bibliothek: Es sind zwei Formen. Ein Paket dafür wären
 * hunderte Kilobyte für zwei Pfade, und die Formen müssten trotzdem an das
 * Farbsystem angepasst werden.
 *
 * Zwei Regeln für alle Symbole hier:
 *
 * * **`currentColor`**, nie eine feste Farbe — sonst verschwinden sie im
 *   jeweils anderen Farbschema oder auf einer Akzentfläche.
 * * **Größe in `em`**, nicht in Pixeln. Damit wachsen sie mit der Schrift des
 *   Elements, in dem sie stehen, statt daneben zu verrutschen.
 */

type Props = {
  /** Kantenlänge, in `em` relativ zur umgebenden Schrift. */
  size?: number
  className?: string
}

/**
 * Sonne: Kern mit acht Strahlen.
 *
 * Die Strahlen sind einzelne Linien statt eines gestrichelten Kreises — so
 * bleiben die Enden rund, und die Form trägt auch bei 16 Pixeln noch.
 */
export function SunIcon({ size = 1.4, className }: Props) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={`${size}em`}
      height={`${size}em`}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="4.2" />
      <path d="M12 2.6v2.3M12 19.1v2.3M21.4 12h-2.3M4.9 12H2.6" />
      <path d="M18.6 5.4l-1.6 1.6M7 17l-1.6 1.6M18.6 18.6L17 17M7 7L5.4 5.4" />
    </svg>
  )
}

/**
 * Mond: Sichel als ein Pfad.
 *
 * Kein Kreis mit ausgestanztem zweiten Kreis — als Umriss gezeichnet passt die
 * Sichel zur Strichstärke der Sonne daneben. Zwei Symbole, die im selben Knopf
 * abwechseln, müssen dasselbe Gewicht haben, sonst springt der Knopf beim
 * Umschalten optisch.
 */
export function MoonIcon({ size = 1.4, className }: Props) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={`${size}em`}
      height={`${size}em`}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path d="M20.2 14.4A8.6 8.6 0 0 1 9.6 3.8a8.6 8.6 0 1 0 10.6 10.6z" />
    </svg>
  )
}
